import React from 'react';
import { HomepageSectionFeatured } from '@gik/homepage/components/SectionFeatured/HomepageSectionFeatured';

export default function HomepageFeaturedPagesContainer({ className }: { className?: string }): JSX.Element {
  return (
    <div className={`homepage-featured-pages-container ${className}`}>
      <HomepageSectionFeatured />
    </div>
  );
}
